// Recovered compiled webpack factory 69512. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { LazyVideo: () => s });
  var n = r(95155),
    a = r(12115);
  function s(e) {
    let { src: t, sources: r, poster: s, label: i, fit: l = "cover", className: o = "" } = e,
      c = (0, a.useRef)(null),
      [d, u] = (0, a.useState)(!1);
    return (
      (0, a.useEffect)(() => {
        let e = window.matchMedia("(prefers-reduced-motion: reduce)"),
          t = () => u(e.matches);
        return (t(), e.addEventListener("change", t), () => e.removeEventListener("change", t));
      }, []),
      (0, a.useEffect)(() => {
        let e = c.current;
        if (!e || d) return;
        let t = !1,
          r = () => {
            let r = t && !document.hidden;
            r && e.paused ? e.play().catch(() => {}) : r || e.paused || e.pause();
          },
          n = new IntersectionObserver(
            (n) => {
              for (let r of n)
                (r.isIntersecting &&
                  "none" === e.preload &&
                  ((e.preload = "auto"), e.children.length > 0 && e.load()),
                  (t = r.isIntersecting));
              r();
            },
            { threshold: 0.2, rootMargin: "300px 0px" },
          );
        return (
          n.observe(e),
          document.addEventListener("visibilitychange", r),
          () => {
            (n.disconnect(), document.removeEventListener("visibilitychange", r));
          }
        );
      }, [d]),
      (0, n.jsx)("video", {
        ref: c,
        className: `h-full w-full ${"contain" === l ? "object-contain" : "object-cover"} ${o}`,
        src: t,
        poster: s,
        "aria-label": i,
        preload: "none",
        muted: !0,
        loop: !0,
        playsInline: !0,
        disablePictureInPicture: !0,
        disableRemotePlayback: !0,
        children:
          null == r
            ? void 0
            : r.map((e) => (0, n.jsx)("source", { src: e.src, type: e.type }, e.src)),
      })
    );
  }
}
